export default {
    title: 'Anfragen',
    id: 'A.-Nummer',
    user_id: 'Ausgeschrieben von',
    positions: 'Positionen',
    status: 'Status',
    category: 'Kategorie',
    tenderingActive: 'Anfrage aktiv',
    tenderOffer: 'Angebot abgegeben',
    acceptedOffer: 'Angebot angenommen',
    visible_until: 'Offen bis',
    created_at: 'Vom',
    createOffer: 'Angebot anlegen / bearbeiten',

    type: 'Beschaffungsart',
    qf_ownOnly: 'Meine Angebote',
    qf_activeRequests: 'Aktive Anfragen',
    qf_acceptedOffersOnly: 'Angenommene Angebote',
    qf_onlySubscribedCategories: 'Abonnierte Kategorien',
}
